const _excluded = ["scdOptions"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/* eslint-disable @typescript-eslint/no-use-before-define */

import React, { useEffect, useState } from 'react';
import isNumber from 'lodash/isNumber';
import { clsx } from 'clsx';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme, ButtonType } from 'common/components/button/constants';
import { SvgIconType } from 'common/components/svg-icon';
import { Placement } from 'common/components/tooltip/types';
import { generateFilterTrackingProps, transformFilterToPropertyItem } from 'common/query-builder/query-block/filter-menu/util';
import { isMultiAttributionFilter } from 'common/query-builder/query-builder/util';
import { Action, EntryPart, isObjectEntry, QueryFilterEntry } from 'common/query-builder/query-entry-section/types';
import { FullPropertyType, PropertyType, ResourceType, SPECIAL_EVENTS } from 'common/report/constants';
import { getIconForPropertyType, isScdPropertyName } from 'common/report/util/properties';
import { QueryReason } from 'common/report/util/query-tracking/types';
import { Segmentation } from 'common/types/reports/query';
import { ActionType, trackLearningAction } from 'common/util/server-tracking';
import { PropertyFilter } from 'common/widgets/property-filter-menu/models/property-filter';
import { isFirstTimeEventFilter, isLookupPropertyFilter } from 'common/widgets/property-filter-menu/models/utils';
import { hasComputedListFilters, isListOfObjectsFilter } from 'common/widgets/property-filter-menu/utils';
import { ControlBarAction, ControlBarActionItem, ControlBarActionItems, ControlBarActionValue } from 'common/query-builder/query-entry-section/constants';
import { getEntryWithProfileHistory } from 'common/query-builder/query-entry-section/util/profile-history';
import { isProperty, Property } from 'common/query-builder/query-block/properties-menu/types';
import { segmentationToPropertyItem } from 'common/query-builder/query-block/properties-menu/util';
import { unregisterTempLookupTableMapping } from 'common/report/stores/lookup-tables';
import { QueryEntrySectionTrackingEvent } from 'common/query-builder/query-entry-section/tracking';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { DateRangeType, TimeUnit } from 'common/widgets/date-range-picker/models/types';
import { getPropertySelectionFromProperty } from 'common/query-builder/query-entry-section/util/behavior';
import { formatDate } from 'common/util/date';
import { useTranslation } from 'common/i18n/hooks';
import { isExperimentSegment } from 'common/query-builder/query-block/segment-menu/types';
import { BaseEntryRow } from '../base';
// eslint-disable-next-line import/no-cycle
import { BehavioralSubFilters, BehavioralSubItem, PropertySelector, RevenueSubItem } from '../behavior/template';
import { getIconForBehavior, isAggregateUserFreqByGroupSegmentation, isEventBasedBehavioralSegmentation, isFrequencyBehavior, isMultiAttributionBehavior, isRevenueBehaviorSegmentation, isTTCSegmentation } from '../behavior/utils';
import { canMapPropToLookupTable, canUnmapPropFromLookupTable, getEntryPropertyType, getPropertyType, isComputedListPropertyEntry, mapLookupTable, populateListPropertyAttrs, populateProfileHistoryOptions, promptRename, setPropertyType } from '../row-util';
import { EntryRowProps } from '../types';
import { BehavioralStepSelectionSubItem } from '../behavior/behavioral-step-selection-subitem';
import { AggregateUserFrequencyByGroupSubItem } from '../behavior/aggregate-user-frequency-by-group-subitem';
import { OPERATORS_WITH_UNIT } from './constants';
import { FilterParts } from './parts';
import { createFilter, getNextEntryPart } from './utils';
// eslint-disable-next-line import/no-cycle
import { helpers } from './helpers';
export function FilterEntryRow(props: EntryRowProps<QueryFilterEntry>) {
  var _props$entry$event6, _props$entry$event7, _props$entry$event$pr, _props$entry$event8, _props$renderSuffix;
  const [entryEl, setEntryEl] = useState<HTMLDivElement>(null);
  const i18n = useTranslation();
  const {
    t
  } = i18n;
  const filter = createFilter(props);
  let hasHourOrMinute = false;
  if (filter.filterValue && typeof filter.filterValue === "object" && "window" in filter.filterValue) {
    var _filter$filterValue, _filter$filterValue2;
    hasHourOrMinute = ((_filter$filterValue = filter.filterValue) === null || _filter$filterValue === void 0 || (_filter$filterValue = _filter$filterValue.window) === null || _filter$filterValue === void 0 ? void 0 : _filter$filterValue.unit) === TimeUnit.Minute || ((_filter$filterValue2 = filter.filterValue) === null || _filter$filterValue2 === void 0 || (_filter$filterValue2 = _filter$filterValue2.window) === null || _filter$filterValue2 === void 0 ? void 0 : _filter$filterValue2.unit) === TimeUnit.Hour;
  }
  const [isTimePickerEnabled, setTimePickerEnabled] = useState(hasHourOrMinute);
  const hasProperty = filter.hasSelectedProperty();
  const isFirstTimeFilter = isFirstTimeEventFilter(filter);
  const isClearAction = props.entry.quickDelete && props.entry.clearable && props.numStagedRows === 2 && !props.hasStagedRow;
  const hasConjunction = props.hasNewUI && props.renderSuffix && props.sectionProps.entries.length > 1 && props.index === 0;
  const isFirstListItemFilter = !!props.sectionProps.listProperty && props.index === 0;
  const isPlaceholder = helpers.isPlaceholder(props);
  const propertyItem = transformFilterToPropertyItem(props.entry.event);
  useEffect(() => {
    // on first mount, focus the filter value section if we're a placeholder with a property
    // autofocus logic should be shifted to this technique (to avoid state race conditions inside of query-entry-section, but this fixes this for filters for now)
    // const isStagingChanges = props.isStagingEntryChanges(props.entry, updatedEntry);
    if (!hasProperty) {
      props.setActivePart(EntryPart.Value, "open");
    } else if (isPlaceholder || filter !== null && filter !== void 0 && filter.behavior) {
      // when changing a committed filter to an invalid filter, or when the filter property
      // is selected for the first time, set focus to the filter value selection
      props.setActivePart(getNextEntryPart(filter), "open");
    }
    // purposely not filling out dependency array to track fresh mounts only. this should be wrapped in a custom hook as to centralize across rows
  }, []);
  const getSelectorIcon = (): SvgIconType => {
    if (props.entry.inheritedFromBoard) {
      return "brand-dashboard-gray";
    }
    if (props.entry.filterOnly) {
      return null;
    }
    if (filter.resourceType === ResourceType.Cohort) {
      return "community";
    }
    if (isExperimentSegment(filter)) {
      return "experiment";
    }
    if (isEventBasedBehavioralSegmentation(filter) || isMultiAttributionBehavior(filter.behavior)) {
      return getIconForBehavior(filter.behavior, true);
    }
    if (!filter.hasSelectedProperty()) {
      return "search";
    }
    if (isFirstTimeFilter) {
      return "time";
    }
    return getIconForPropertyType(getPropertyType(props.entry.event), {
      isCustom: Boolean(filter === null || filter === void 0 ? void 0 : filter.customProperty),
      isScd: !!filter.scdEvent
    });
  };
  const handlePropertySelect = (selection: PropertyFilter, queryReason?: QueryReason, trackingProps?: Obj) => {
    selection = populateListPropertyAttrs(selection);
    if (props.isProfileHistoryEnabled) {
      selection = populateProfileHistoryOptions(selection, props.sectionProps.hideEvents);
    }

    // persist the selected filter operator and filter value if changing between same property types
    if (selection.resourceType !== ResourceType.Cohort && filter.propertyType === selection.propertyType) {
      selection.filterValue = filter.filterValue;
      selection.filterOperator = filter.filterOperator;
      if (selection.joinPropertyType === PropertyType.List || isLookupPropertyFilter(filter)) {
        selection.listQuantifier = filter.listQuantifier;
      }
    }
    updateEntry(selection, {
      trackingProps,
      queryReason
    });
  };
  const onChangeOperator = () => {
    // focus on filter value when operator changes filter to an invalid state
    if (!filter.isValid()) {
      props.setActivePart(EntryPart.FilterValue, "open");
    }
  };
  const updateEntry = function updateEntry(propFilter: PropertyFilter) {
    let {
      trackingProps,
      queryReason
    }: Partial<{
      trackingProps: Obj;
      queryReason: QueryReason;
    }> = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const updatedEntry: QueryFilterEntry = _objectSpread(_objectSpread({}, props.entry), {}, {
      event: propFilter instanceof PropertyFilter ? propFilter.getAttributes() : propFilter
    });

    // The filter-menu will pass through queryReason in which case we should use that queryReason.
    queryReason = queryReason || QueryReason.QbFilterUpdate;
    const updateStatus = props.updateEntry(Action.Edit, updatedEntry, {
      trackingProps: trackingProps !== null && trackingProps !== void 0 ? trackingProps : generateFilterTrackingProps(propFilter),
      queryReason
    });
    if (queryReason !== QueryReason.QbAutoTriggered && updateStatus.dispatchedUpdate && !props.entry.suppressTracking) {
      // We don't want to track learning action until the complete filter has been created
      trackLearningAction({
        projectId: props.sectionProps.projectId,
        reportName: props.sectionProps.trackName,
        actionType: ActionType.Filter,
        resourceType: propFilter.resourceType
      });
    }
  };
  const performTypecast = (toType: FullPropertyType) => {
    // do nothing if selecting the same type
    const currentType = getPropertyType(props.entry.event);
    if (currentType.type === toType.type && currentType.isList === toType.isList) {
      return;
    }
    const event = setPropertyType(props.entry.event, toType, true);
    props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      event
    }));
  };
  const handleControlSelect = (value: ControlBarActionValue) => {
    switch (value.action) {
      case ControlBarAction.Typecast:
        performTypecast(value.toType);
        break;
      case ControlBarAction.ProfileHistory:
        props.updateEntry(Action.Edit, getEntryWithProfileHistory(props.entry, value.toType), {
          trackingProps: {
            'Profile History Type': value.toType
          }
        });
        break;
      case ControlBarAction.AddScdMeasurements:
        {
          var _props$entry$event$sc, _props$entry$event$sc2;
          const scdType = (_props$entry$event$sc = (_props$entry$event$sc2 = props.entry.event.scdOptions) === null || _props$entry$event$sc2 === void 0 ? void 0 : _props$entry$event$sc2.type) !== null && _props$entry$event$sc !== void 0 ? _props$entry$event$sc : "latest";
          props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
            event: _objectSpread(_objectSpread({}, props.entry.event), {}, {
              scdOptions: {
                type: scdType,
                dateRange: scdType === "latest" ? {
                  type: DateRangeType.On,
                  to: formatDate(new Date(), {
                    iso: true
                  }),
                  from: formatDate(new Date(), {
                    iso: true
                  })
                } : {
                  type: DateRangeType.RelativeAfter,
                  window: {
                    unit: TimeUnit.Week,
                    value: 4
                  }
                }
              }
            })
          }));
          break;
        }
      case ControlBarAction.RemoveScdMeasurements:
        {
          // deleting scd options date range
          const _props$entry$event = props.entry.event,
            {
              scdOptions
            } = _props$entry$event,
            event = _objectWithoutProperties(_props$entry$event, _excluded);
          props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
            event: _objectSpread(_objectSpread({}, event), {}, {
              scdOptions: {
                // any option requires a date range, so we can't keep that
                type: "latest"
              }
            })
          }));
          break;
        }
      case ControlBarAction.MapLookupTable:
        mapLookupTable(props, props.entry.event as Segmentation);
        break;
      case ControlBarAction.UnmapLookupTable:
        unregisterTempLookupTableMapping(segmentationToPropertyItem(props.entry.event as Segmentation));
        props.dispatchTrack(QueryEntrySectionTrackingEvent.UnmappedTable, props.getEntryTrackingProps());
        addToast({
          message: "Removed temporary lookup table mapping",
          type: ToastType.DESTRUCTIVE
        });
        break;
      default:
        props.onControlSelect(value);
    }
  };
  const getUnit = () => {
    var _props$entry$event2, _props$entry$event3, _props$entry$event4;
    const filterValue = (_props$entry$event2 = props.entry.event) === null || _props$entry$event2 === void 0 ? void 0 : _props$entry$event2.filterValue;
    // For lists we just put 2 to represent that it's always plural
    const val = Array.isArray(filterValue) ? 2 : (_props$entry$event3 = props.entry.event) === null || _props$entry$event3 === void 0 ? void 0 : _props$entry$event3.filterValue;
    if (props.hasNewUI && isAggregateUserFreqByGroupSegmentation(props.entry.event as Segmentation)) {
      return "Users";
    } else if (
    // TODO disable for now while we work on diff designs
    isNumber(val) && isFrequencyBehavior((_props$entry$event4 = props.entry.event) === null || _props$entry$event4 === void 0 ? void 0 : _props$entry$event4.behavior) && OPERATORS_WITH_UNIT.includes(props.entry.event.filterOperator)) {
      return null;
      // return pluralize(`time`, val);
    }
    return null;
  };
  const selectorRenderer = _ref => {
    var _props$placeholder, _props$entry$event5;
    let {
      rowActions
    } = _ref;
    let eventNames = props.sectionProps.eventNames;
    // For attribution filters, we need to query against all events because due
    // to the nature of attribution, the values are spread across all events, not
    // just the ones included in the query.
    if (isMultiAttributionFilter(filter)) {
      eventNames = [...eventNames, SPECIAL_EVENTS.ALL_EVENTS];
      // For SCD filters we just want the values from the SCD event itself
    } else if (filter.scdEvent) {
      eventNames = [filter.scdEvent];
    }
    const filterParts = <FilterParts filter={filter} hideListQuantifier={props.entry.hideListQuantifier} hasNewUI={props.hasNewUI} isValueActive={props.activePart === EntryPart.FilterValue} setActiveEntry={state => props.setActivePart(EntryPart.FilterValue, state)} updateEntry={propFilter => updateEntry(propFilter)} onValueSelectMenuChange={ev => props.onSelectMenuChange(ev, EntryPart.FilterValue)} onChangeOperator={onChangeOperator} operatorOverrides={props.entry.operatorOverrides} hasPlaceholder={((_props$placeholder = props.placeholder) === null || _props$placeholder === void 0 ? void 0 : _props$placeholder[0]) === EntryPart.FilterValue} eventNames={eventNames} projectId={props.sectionProps.projectId} workspaceId={props.sectionProps.workspaceId} userId={props.sectionProps.userId} dataGroupId={props.sectionProps.dataGroupId} readonly={props.sectionProps.readonly} withQuickDelete={props.entry.filterOnly && props.entry.quickDelete} withQuickRename={props.entry.filterOnly && props.entry.quickRename} showTypecastControl={!props.entry.filterOnly && filter.resourceType !== ResourceType.Cohort} disabledTypecastTypes={props.sectionProps.disabledTypecastTypes} rowActions={rowActions} unit={getUnit()} isProfileHistoryEnabled={props.isProfileHistoryEnabled} hideEvents={props.sectionProps.hideEvents} isTimePickerEnabled={isTimePickerEnabled} setTimePickerEnabled={setTimePickerEnabled} valueDisabled={props.entry.valueDisabled} valueTooltip={props.entry.valueTooltip} disableScdDateRange={props.sectionProps.sectionName === "inline-cohort"} />;
    return props.entry.filterOnly ? <>
        {props.entry.quickDelete && <ButtonReact className={clsx("mp-query-entry-delete-row", {
        'is-clear-action': isClearAction
      })} elref='filterDeleteButton' theme={ButtonTheme.Tertiary} icon='x' type={ButtonType.Destructive} tooltip={{
        'delay-in': 10,
        'delay-out': 10,
        placement: Placement.Bottom,
        text: _ref2 => {
          let {
            t: trans
          } = _ref2;
          return trans("filters.menu.remove-values");
        }
      }} onClick={() => props.removeEntry()} />}
        {props.entry.quickRename && <ButtonReact className='mp-query-entry-rename-row' elref='filterRenameButton' theme={ButtonTheme.Tertiary} icon='edit' type={ButtonType.Base} tooltip={{
        'delay-in': 10,
        'delay-out': 10,
        placement: Placement.Bottom,
        text: _ref3 => {
          let {
            t: trans
          } = _ref3;
          return trans("filters.menu.rename-values");
        }
      }} onClick={() => promptRename(props, i18n)} />}
        {filterParts}
      </> : <>
        {/** main selector */}

        <PropertySelector {...props}
      // only put in icons for cohort builder
      queryBlockConfig={_objectSpread(_objectSpread({}, props.queryBlockConfig), {}, {
        listProperty: props.sectionProps.listProperty
      })} selectorIcon={props.hasNewUI ? null : getSelectorIcon()} contextPanelParentElement={entryEl} onSelect={(selectedItem, queryReason) => {
        const selected = props.entry.event instanceof PropertyFilter ? props.entry.event.getAttributes() : props.entry.event as Segmentation;
        const handledEvent = getPropertySelectionFromProperty(selectedItem, selected, {
          isForFilter: true,
          reportName: props.sectionProps.reportName,
          dataGroupId: props.sectionProps.dataGroupId,
          chartType: props.sectionProps.chartType,
          dateUnit: props.sectionProps.dateUnit
        }) as PropertyFilter;
        handlePropertySelect(handledEvent, queryReason);
      }} isPlaceholder={isPlaceholder} selected={props.entry.event instanceof PropertyFilter ? props.entry.event.getAttributes() : props.entry.event as Segmentation} isForFilter data-sentry-element="PropertySelector" data-sentry-source-file="index.tsx" />
        {/* renders behavioral controls (time & aggregation) for the selected property */}
        {isEventBasedBehavioralSegmentation(props.entry.event as Segmentation) && ((_props$entry$event5 = props.entry.event) === null || _props$entry$event5 === void 0 ? void 0 : _props$entry$event5["behavior"]) && <BehavioralSubItem {...props} contextPanelParentElement={entryEl} selected={props.entry.event instanceof PropertyFilter ? props.entry.event.getAttributes() : props.entry.event as Segmentation} onSelect={handlePropertySelect} isPlaceholder={isPlaceholder} />}

        {isRevenueBehaviorSegmentation(props.entry.event as Segmentation) && <RevenueSubItem {...props} contextPanelParentElement={entryEl} selected={props.entry.event instanceof PropertyFilter ? props.entry.event.getAttributes() : props.entry.event as Segmentation} isForFilter onSelect={handlePropertySelect} isPlaceholder={isPlaceholder} />}

        {isAggregateUserFreqByGroupSegmentation(props.entry.event as Segmentation) && <AggregateUserFrequencyByGroupSubItem {...props} contextPanelParentElement={entryEl} selected={props.entry.event instanceof PropertyFilter ? props.entry.event.getAttributes() : props.entry.event as Segmentation} onSelect={handlePropertySelect} isPlaceholder={isPlaceholder} isFilter extraFilters={filterParts} />}

        {isTTCSegmentation(props.entry.event as Segmentation) && <BehavioralStepSelectionSubItem className='step-selection' stepCount={props.sectionProps.stepCount} selected={props.entry.event instanceof PropertyFilter ? props.entry.event.getAttributes() : props.entry.event as Segmentation} onChange={handlePropertySelect} />}
        {/* filter parts */}
        {hasProperty && !isAggregateUserFreqByGroupSegmentation(props.entry.event as Segmentation) ? filterParts : null}
      </>;
  };
  const suffixRenderer = () => <>
      {/* renders filters applied to a behavior's event */}
      {<BehavioralSubFilters {...props} onSelect={handlePropertySelect} selected={props.entry.event as Segmentation} />}
    </>;
  const actionsRenderer = () => props.entry.inheritedFromBoard && props.entry.event ? <ButtonReact theme={ButtonTheme.Tertiary} icon={props.entry.event.isHidden ? "eye-on" : "eye-hide"} role='button' tooltip={{
    text: props.entry.event.isHidden ? t("common.show") : t("common.hide"),
    placement: Placement.Top
  }} onClick={() => {
    props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      event: _objectSpread(_objectSpread({}, props.entry.event), {}, {
        isHidden: !props.entry.event.isHidden
      })
    }));
  }} /> : <>
        {isListOfObjectsFilter(filter) && hasComputedListFilters(filter) === false && <ButtonReact elref='addItemFilterButton' theme={ButtonTheme.Tertiary} icon='plus' role='button' tooltip={{
      text: "Add",
      placement: Placement.Top
    }} onClick={() => props.showPlaceholder(EntryPart.FilterValue)} />}
      </>;
  const showScdOverflowControls = !props.hasNewUI && isScdPropertyName((_props$entry$event6 = props.entry.event) === null || _props$entry$event6 === void 0 ? void 0 : _props$entry$event6.propertyName) && !isFirstTimeFilter && filter.resourceType === ResourceType.User && props.sectionProps.sectionName !== "inline-cohort";
  const hasScdDateRange = !!((_props$entry$event7 = props.entry.event) !== null && _props$entry$event7 !== void 0 && (_props$entry$event7 = _props$entry$event7.scdOptions) !== null && _props$entry$event7 !== void 0 && _props$entry$event7.dateRange);
  const overflowControls: ControlBarActionItem[] = [...props.getCommonOverflowControls(),
  // profile history
  props.isProfileHistoryEnabled && !isFirstTimeFilter && filter.resourceType === ResourceType.User && ControlBarActionItems[ControlBarAction.ProfileHistory]({
    currentProfileHistoryType: (_props$entry$event$pr = props.entry.event.profileHistoryOptions) === null || _props$entry$event$pr === void 0 ? void 0 : _props$entry$event$pr.type,
    hideEvents: props.sectionProps.hideEvents,
    selectorType: props.entry.type
  }),
  // scd
  showScdOverflowControls && !hasScdDateRange && ControlBarActionItems[ControlBarAction.AddScdMeasurements], showScdOverflowControls && hasScdDateRange && ControlBarActionItems[ControlBarAction.RemoveScdMeasurements],
  // typecasting
  hasProperty && !isComputedListPropertyEntry(props.entry) && !props.sectionProps.disableTypecast && !isFirstTimeFilter && filter.resourceType !== ResourceType.Cohort && ControlBarActionItems[ControlBarAction.Typecast](getEntryPropertyType(props.entry), {
    disabledTypes: props.sectionProps.disabledTypecastTypes
  }),
  // map to lookup table
  !isPlaceholder && !props.sectionProps.disableMapToLookupTable && !isObjectEntry(props.entry) && !Array.isArray(propertyItem) && isProperty(propertyItem) && canMapPropToLookupTable(propertyItem) && ControlBarActionItems[ControlBarAction.MapLookupTable],
  // unmap from lookup table
  !isPlaceholder && canUnmapPropFromLookupTable(propertyItem as Property) && ControlBarActionItems[ControlBarAction.UnmapLookupTable]];
  return <BaseEntryRow ref={setEntryEl} {...props} entry={_objectSpread(_objectSpread({}, props.entry), {}, {
    isHidden: (_props$entry$event8 = props.entry.event) === null || _props$entry$event8 === void 0 ? void 0 : _props$entry$event8.isHidden
  })} hideActions={props.entry.filterOnly || !props.hasNewUI && (isListOfObjectsFilter(filter) || isFirstListItemFilter)} extraEntryClass={{
    'is-filter-only': props.entry.filterOnly,
    'is-first-time-filter': filter && isFirstTimeFilter,
    'has-conjunction': hasConjunction
  }} showDefaultMetricUnitSelector={false} renderSelector={selectorRenderer} renderSuffix={(_props$renderSuffix = props.renderSuffix) !== null && _props$renderSuffix !== void 0 ? _props$renderSuffix : suffixRenderer} renderActions={actionsRenderer} isPlaceholder={isPlaceholder} entryIcon={getSelectorIcon()} onControlSelect={handleControlSelect} canDelete={!props.entry.inheritedFromBoard && props.canDelete} disabled={props.entry.inheritedFromBoard} tooltip={props.entry.inheritedFromBoard ? t("query-builder.filter-inherited-from-board") : ""} overflowControls={isFirstTimeFilter || props.entry.inheritedFromBoard ? [] : overflowControls} data-sentry-element="BaseEntryRow" data-sentry-component="FilterEntryRow" data-sentry-source-file="index.tsx" />;
}